import {
    ref
} from 'vue';

export function useFps(options = {
    every: 10
}) {
    const fps = ref(0);
    let lastTime = performance.now();
    let ticks = 0;
    let rafId = null;
    const {
        every
    } = options;

    const update = () => {
        const now = performance.now();
        ticks++;

        // 每 100ms 计算一次 FPS
        if (now - lastTime >= 100) {
            fps.value = Math.round((ticks * 1000) / (now - lastTime));
            lastTime = now;
            ticks = 0;
        }

        rafId = requestAnimationFrame(update);
    };

    rafId = requestAnimationFrame(update);

    // 提供停止方法
    const stop = () => {
        if (rafId !== null) {
            cancelAnimationFrame(rafId);
            rafId = null;
        }
    };

    return {
        fps,
        stop
    };
}